// extracted by mini-css-extract-plugin
export var askAiIcon = "_qk-9";
export var container = "_qk-0";
export var groupSeparator = "_qk-a";
export var highlight = "_qk-4";
export var resultIcon = "_qk-5";
export var resultItem = "_qk-7";
export var resultSubtitle = "_qk-3";
export var resultTitle = "_qk-2";
export var resultsList = "_qk-1";
export var searchGroup = "_qk-6";
export var selected = "_qk-8";